import { BsGear } from "react-icons/bs";
import styled from "styled-components";
import dekra from "../style/dekra";

const ConfigButtonWrapper = styled.div`
  font-size: 1.2em;
  cursor: pointer;
  color: ${dekra.primaryColor};
  margin-top: 8px;
  display: flex;
  align-items: center;

  svg {
    font-size: 1.4em;
  }
`;

const ConfigModal = () => {
  const handleOnResetData = async () => {
    await fetch("/reset-data", {
      method: "GET",
    });
  };

  return (
    <ConfigButtonWrapper onClick={handleOnResetData}>
      <BsGear />
      <span style={{ marginLeft: "1em" }}>INIT INDEX DB</span>
    </ConfigButtonWrapper>
  );
};

export default ConfigModal;
